module.exports = __webpack_public_path__ + "img/rebuild_huang_pc4.023b1861.jpg";